import { DOCUMENT_ID_TYPES } from "../../../../income/DeclaredIncome/config";
import { docIdTypes, documentTypes } from "../../../shared/config";

export const findDocumentByParticipantDocumentType = (documentType) => {
  switch (documentType) {
    case DOCUMENT_ID_TYPES.NIE_EU:
      return [documentTypes.find((type) => type.id === docIdTypes.NIE_UE)];
    case DOCUMENT_ID_TYPES.NIE_NON_EU:
      return [documentTypes.find((type) => type.id === docIdTypes.NIE_NON_UE)];
    case DOCUMENT_ID_TYPES.NIF:
      return [documentTypes.find((type) => type.id === docIdTypes.DNI_ES)];
    case DOCUMENT_ID_TYPES.PASSPORT:
      return [documentTypes.find((type) => type.id === docIdTypes.PASSPORT)];
    default:
      return documentTypes;
  }
};
